import { useQuery } from 'react-query';
import { sdk } from '../../../../API/TT_ELD/mobile/sdk';

type SDKParams = {
  page?: number;
  perPage?: string;
  is_active?: boolean;
};

export const useSDK = (type: 'MCU' | 'BLE', filterObject: SDKParams = {}) => {
  return useQuery(['dashcam-sdk', type, filterObject], () => sdk.readSDK(type, filterObject), {
    refetchOnWindowFocus: false,
  });
};
